import React from 'react';
import { Navigate } from 'react-router-dom';
import { useGetAuth0MeQuery } from '@/store/api/userApi';
import LoadingScreen from '../common/LoadingScreen';

interface RequirePermissionProps {
  children: React.ReactNode;
  requiredPermission: string;
  redirectTo?: string;
}

const RequirePermission: React.FC<RequirePermissionProps> = ({
  children,
  requiredPermission,
  redirectTo = '/unauthorized',
}) => {
  const { data: auth0MeData, isLoading } = useGetAuth0MeQuery();

  if (isLoading) {
    return <LoadingScreen />;
  }

  const allowedActions = auth0MeData?.user?.allowed_ui_actions || [];
  const hasPermission = allowedActions.includes(requiredPermission);

  if (!hasPermission) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};

export default RequirePermission;
